export default {
  path: '',
  component: () => import('@/views/uspqrp/budget/Wrapper.vue'),
  children: [
    {
      path: '/uspqrp/budget',
      name: 'Budget',
      component: () => import('@/views/uspqrp/budget/Main.vue'),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.uspqrp.budget'],
        },
      },
    },
  ],
};
